module.exports = __webpack_public_path__ + "img/oni_frame_holder_hands.070633b5.png";